import React from "react";

const PubContact = () => (
    <section className="pub-contact">
        <div className="pub-contact-inner">
            <h2 className="pub-contact-heading">Start with your first verified record.</h2>
            <p className="pub-contact-sub">
                Tell us about a project or portfolio and we'll show you what a verified record looks like on Conra.
            </p>
            <a
                className="filled-button"
                href="https://web.conra.net"
                target="_blank"
                rel="noopener noreferrer"
            >
                Get Started
            </a>
        </div>
    </section>
);

export default PubContact;
